'use client';

import ExpandableFAQ from './ExpandableFAQ';

interface FAQItem {
  question: string;
  answer: React.ReactNode;
}

interface FAQSectionProps {
  title?: string;
  faqs: FAQItem[];
}

export default function FAQSection({ title = "Frequently Asked Questions", faqs }: FAQSectionProps) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-100">
      <div className="px-4 sm:px-6 py-4 sm:py-6 border-b border-gray-100">
        <h2 id="frequently-asked-questions" className="text-xl sm:text-2xl font-medium text-gray-900 scroll-mt-24">{title}</h2>
      </div>
      <div className="divide-y divide-gray-100">
        {faqs.map((faq, index) => (
          <div key={index} className="px-4 sm:px-6 py-3 sm:py-4">
            <ExpandableFAQ question={faq.question} answer={faq.answer} />
          </div>
        ))}
      </div>
    </div>
  );
} 